import func from '@/script/func';
const state = {
    info: {
        __process: 1,
        __js: "/erpcron/index.js",
        __process_id: "",
    },
}
const mutations = {
    setProcessId(state, processId) {
        state.info.__process_id = processId;
    },
}
const actions = {
    async init({ state, commit, rootState }) {
        let p = func.sget("process_list");
        if (p && p.erpcron) {
            commit("setProcessId", p.erpcron)
        } else {
            let rs = await rootState.eapi.invoke("fork@create", state.info);
            if (rs.code == 1) {
                let p2 = func.sget("process_list");
                if (!p2) {
                    p2 = {};
                }
                p2.erpcron = rs.__process_id;
                func.ssave("process_list", p2)
                commit("setProcessId", rs.__process_id)
            } else {
                console.warn("------------------创建erpcron子进程失败");
                return;
            }
        }
        await rootState.eapi.invoke("erpcron@run", state.info, 20000);
    },
}
const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
